module.exports = __webpack_public_path__ + "static/templat_attracnt-a2777ac3067f38e4697c095ea4396a0b.png";